import {Component, EventEmitter, Input, Output,} from '@angular/core';
import {AddressDatabaseService} from "../../../open-api-generated/services/address-database.service";

@Component({
  selector: 'search-locality-street-select',
  templateUrl: './search-locality-street-select.component.html',
  styleUrls: ['./search-locality-street-select.component.scss']
})
export class SearchLocalityStreetSelectComponent {
  @Input('localityId') localityId = null;
  @Input('disabled') disabled: boolean = true;
  @Output('onAddressDetailsChangedEvent') onAddressDetailsChangedEvent: EventEmitter<string> = new EventEmitter<string>;

  @Input('details') details: string  = null;

  streets: any[] = [];

  constructor(
    private addressDatabaseService: AddressDatabaseService
  ) {
  }

  searchStreet(input: any): void {
    this.streets = [];
    if (input.value.length < 3) {
      return;
    }

    this.addressDatabaseService.appV2AddressDatabaseLocalityStreetSearch({
      localityId: this.localityId,
      query: input.value,
    }).subscribe(
      (streets: any[]): void => {
        this.streets = streets;
      }
    );
  }

  setStreet(street: any): void {
    this.details = street.type + ' ' + street.name;
    this.streets = [];
    this.onAddressDetailsChangedEvent.emit(this.details);
  }
}
